export default __webpack_public_path__ + "static/media/newlo.b8fd6451.svg";